import React from 'react'

import { Loader, useBreakpoints } from '@procsea/design-system'

import { LoaderContainer } from './PageLoader.styles'

const PageLoader = () => {
  const { activeBreakpoint } = useBreakpoints()
  return (
    <LoaderContainer data-e2e="page-loader" activeBreakpoint={activeBreakpoint}>
      <Loader centered />
    </LoaderContainer>
  )
}

export default PageLoader
